// ANCHOR: CACHE_CONFIG_START
export const CacheConfig = {
  // Blob URL 缓存配置
  blobUrlCache: {
    ramBudgetMB: 384, // 内存预算 384MB
    entryTtlMs: 300_000, // 条目 TTL 5 分钟
    validationCacheTtlMs: 60_000, // 验证缓存 TTL 1 分钟
    enableValidationCache: true // 启用验证缓存
  },
  
  // OPFS 缓存配置
  opfsCache: {
    maxBytes: 2 * 1024 * 1024 * 1024, // 默认 2GB
    ttlDays: 7, // 保留 7 天
    quotaRatio: 0.6 // 不超过可用空间 60%
  },
  
  // 预加载调度器配置
  preloadScheduler: {
    ramBudgetMB: 384,
    maxConcurrent: 8, // 增加最大并发数，为WebM视频预留更多并发槽位
    audioWindowSec: 8, // 减少音频预加载窗口，降低音频预加载压力
    videoWindowSec: 6, // 增加视频预加载窗口，提升视频预加载效果
    // 🆕 WebM视频保护配置
    webmProtection: {
      reservedConcurrent: 2, // 为WebM视频预留2个并发槽位
      audioThrottleFactor: 0.7, // 音频预加载节流因子
      enableWebMDetection: true // 启用WebM检测
    },
    // 暂停态 seek 空闲后的深度预热（Tier2）：向前看窗口，不阻塞 UI
    deepPrewarm: {
      windowSec: 12, // 播放头后 12s
      idleMs: 500, // 真正静止后再跑（trailing debounce）
      maxConcurrent: 2, // 低优先级，≤ Tier1
      ramUsageSkipRatio: 0.9 // BlobUrlCache 用量 ≥ 90% 时跳过本轮
    }
  },
  
  // 媒体缓存配置
  mediaCache: {
    maxCacheSize: 100, // 最大缓存文件数
    cacheExpiry: 24 * 60 * 60 * 1000 // 24 小时过期
  }
};
// ANCHOR: CACHE_CONFIG_END
